import { FeatureConfig } from "@voxmedia/duet-context/context/config-context";

export const FEATURE_CONFIG: FeatureConfig = {
  useLiveStreamUpdates: true,
  useQuickPosts: true,
  subcategoryLimit: 14,
  breadcrumbStrategy: "flat",
  useBoostedPosts: true,
};
